import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <span className="text-xs font-medium uppercase tracking-wider text-secondary-500">
            The Easiest Way to Compare
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3 mb-8">
            What is GTBuy Spreadsheet?
          </h2>

          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
            <strong>GTBuy Spreadsheet is a structured product comparison system that helps users evaluate products across multiple platforms using real-time spreadsheet data.</strong> We combine insights from Kakobuy Spreadsheet and Superbuy Spreadsheet to create the best spreadsheet for product comparison available today. Our data-driven approach eliminates fake reviews and shows real price differences across platforms.
          </p>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
            Unlike traditional shopping methods that rely on subjective opinions and marketing hype, the spreadsheet shopping tool methodology gives you cold, hard data. Whether you are tracking the latest sneaker releases, comparing hoodie prices across international sellers, or hunting for the best tech deals, the structured spreadsheet format makes price tracking effortless and transparent. The real-time product comparison spreadsheet updates continuously so you always see current prices, not cached data from days ago.
          </p>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8">
            Ready to transform how you shop? Explore our complete guide to learn everything about the GTBuy Spreadsheet system and start making smarter, data-backed purchasing decisions today.
          </p>

          <Link
            to="/article/gtbuy-spreadsheet-complete-guide"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-semibold bg-foreground-900 text-white hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}